(async () => {
    const navInitStart = performance.now();
    console.log('[Navigation] Desktop navigation script loaded, initializing...');
    
    const { Core } = await importModule('Core');
    const { $hover } = await importModule('Utils');
 
    customElements.define('main-navigation', class extends Core {
        elements = {
            dropdowns: '*[data-drop]'
        }
        render() {
            const navInitTime = performance.now() - navInitStart;
            console.log('[Navigation] Desktop navigation initialized in:', navInitTime.toFixed(2), 'ms');
            // this.$dropdowns.map(this._handleDropdown.bind(this))
 
          const nav_megaLinks_arr = this.querySelectorAll('.main-navigation-list-secondary > li[data-drop] > a');
          if(nav_megaLinks_arr.length) {
 
            nav_megaLinks_arr.forEach(function (nav_link,index) {
               nav_link.addEventListener('click',function (e) {
                e.preventDefault();
                let parentEl = this.closest('li[data-drop]');
                if(parentEl) {
                  parentEl.classList.toggle('hover');
 
                  let lights_outEl = document.querySelector('lights-out');
                  if(lights_outEl) {
                    if( parentEl.classList.contains('hover')) {
                        
                        for (let sibling of parentEl.parentNode.children) {
                        if (sibling !== parentEl) sibling.classList.remove('hover');
                        }
 
                        
                      lights_outEl.setAttribute('on', '');
                    } else {
                       lights_outEl.removeAttribute('on');
                    }
                  }
                }
              });
            });
 
            document.addEventListener('click', function(e){
  	var el = e.target;
    if(el.tagName == 'LIGHTS-OUT') {
       if(el.hasAttribute('on')) {
         let activeNavEl = document.querySelector('.main-navigation-item.hover');
        if(activeNavEl)  {
          activeNavEl.classList.remove('hover');
           el.removeAttribute('on');
          
        }
       }
    }
  });
 
           
          }

          var mainNavLinks = this.querySelectorAll('.main-navigation-main-list-item');
          if (mainNavLinks.length) {
            mainNavLinks.forEach(function (item) {
              item.addEventListener('click',function (e) {
                e.preventDefault();
                var index = this.getAttribute('data-index');
                var secondaryNavs = this.closest('.main-heder-section').querySelectorAll('.main-navigation-second-level-list');


                  var lightsOutEl = document.querySelector('lights-out');
                  if (lightsOutEl) {
                    if (lightsOutEl.hasAttribute('on')) {
                      let activeNavEl = document.querySelector('.main-navigation-item.hover');
                      if(activeNavEl)  {
                        activeNavEl.classList.remove('hover');
                        lightsOutEl.removeAttribute('on');
                      }
                     }
                  }
                


                 if (this.classList.contains('is-active')) {
                if (secondaryNavs.length) {
                    secondaryNavs.forEach(function (el) {               
                        el.classList.remove('is-active');                  
                    });
                  }
                mainNavLinks.forEach(function (el) {
                  el.classList.remove('is-active');
                }); 
                 }else{
                    mainNavLinks.forEach(function (el) {
                              el.classList.remove('is-active');
                      });
                    this.classList.add('is-active');
                  
                  if (secondaryNavs.length) {
                    secondaryNavs.forEach(function (el) {
                      if (index == el.getAttribute('data-index')) {
                        el.classList.add('is-active');
                      } else {
                        el.classList.remove('is-active');
                      }
                    });
                  }
                 }
               

                const header = document.querySelector('.main-heder-section');
                document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
              });
            });
          }
        }
        _handleDropdown(drop) {
            // $hover(drop, (e, state) => this.publish('lights-out', state));
        }
    });
})();